import { ComponentAlignment, RawSpacingInput, Separator } from '@makyoapp/makyo-tw-ui'

import { CoreComponentInfos } from '@/core/models/app-components/types'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { ComponentSettingKey } from '@/shared/builder'
import { getSafely } from '@/shared/safely'

import { CompOverlayDevmode } from '../../shared/CompOverlayDevmode'

export interface CompDividerWrapperCoreProps {
  infos: CoreComponentInfos
}

/**
 * CompDividerWrapperCore
 *
 * todo: useTypographyStylePropsV2
 */
export const CompDividerWrapperCore = ({
  infos: { component, settings, currentParentBg },
}: CompDividerWrapperCoreProps) => {
  const { isDevelopmentMode, openComponentSettings } = useAppBuilderContext()

  // ========================= design =========================

  const compAlignment = getSafely(
    settings,
    [ComponentSettingKey.DividerDesignComponentAlignment],
    'center'
  ) as ComponentAlignment
  const margin = settings[ComponentSettingKey.DividerDesignMargin] as RawSpacingInput
  const lineThickness = getSafely(settings, [ComponentSettingKey.DividerDesignLineThickness], ['1px'])[0]

  const width = getSafely(settings, [ComponentSettingKey.DividerDesignWidth], ['100%'])[0]

  const dividerColor = settings[ComponentSettingKey.DividerDesignColor]
  const dividerColorSolid = settings[ComponentSettingKey.DividerDesignColorSolid] || 'primary-40'
  const dividerColorStartGradient = settings[ComponentSettingKey.DividerDesignColorStartGradient] || 'primary-40'
  const dividerColorEndGradient = settings[ComponentSettingKey.DividerDesignColorEndGradient] || 'primary-40'
  const dividerColorGradientDirection = settings[ComponentSettingKey.DividerDesignColorGradientDirection]

  const handleClick = () => {
    openComponentSettings(component)
    if (isDevelopmentMode) return
  }

  const dividerComponent = (
    <Separator
      width={width}
      alignment={compAlignment}
      margin={margin}
      height={lineThickness}
      backgroundColor={currentParentBg}
      lineColorType={dividerColor}
      lineColorSolid={dividerColorSolid}
      lineColorStartGradient={dividerColorStartGradient}
      lineColorEndGradient={dividerColorEndGradient}
      lineColorGradientDirection={dividerColorGradientDirection}
    />
  )

  if (isDevelopmentMode) {
    return (
      <div className='relative inline-block w-full border border-dashed' style={{ borderColor: '#333' }}>
        {dividerComponent}
        <CompOverlayDevmode handleClick={handleClick} />
      </div>
    )
  }

  return dividerComponent
}
